import { Column } from 'components/Blocks';

import success from 'assets/animations/success.json';

import { SVGAnimation } from 'components/SVGAnimation';

function Success(): JSX.Element {
  return (
    <Column alignItems="center">
      <SVGAnimation size={144} animationData={success} />

      <h5 className="text-success">Success!</h5>

      <p>The information on your document is valid.</p>
    </Column>
  );
}

export default Success;
